import { Clock, XCircle } from 'lucide-react';

// Shared "your application isn't approved yet" screen for every
// driver-facing page except My Profile (drivers still need to be able to
// view/edit their info and upload documents while pending). Was only ever
// shown on Load Board -- Active Load and Financials rendered their normal
// (empty) UI to a driver who wasn't approved yet, which leaked no real data
// but looked like a broken/empty app rather than "you're not approved yet".
//
// Takes the driver's real approval_status instead of assuming Pending --
// every call site was gating on `approval_status !== 'Approved'`, which
// also catches Rejected, and a rejected driver was being told "Pending
// Review... we'll be in touch" as if their application was still being
// considered.
export default function PendingApprovalNotice({ status }) {
  const isRejected = status === 'Rejected';
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
      <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 border ${isRejected ? 'bg-red-500/10 border-red-500/30' : 'bg-amber-500/10 border-amber-500/30'}`}>
        {isRejected
          ? <XCircle className="w-8 h-8 text-red-400" />
          : <Clock className="w-8 h-8 text-amber-400" />}
      </div>
      <h2 className="font-space font-bold text-2xl text-foreground mb-2">
        {isRejected ? 'Application Not Approved' : 'Application Under Review'}
      </h2>
      <p className="text-muted-foreground text-sm max-w-md leading-relaxed">
        {isRejected
          ? "Your driver application was not approved. If you believe this is a mistake or have questions, please contact your dispatcher or the office directly."
          : "Your driver application has been submitted and is currently being reviewed by our team. You'll receive an email and text message once you've been approved and can start searching loads."}
      </p>
      {!isRejected && (
        <div className="mt-6 px-4 py-3 rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-400 text-xs">
          Status: <strong>Pending Review</strong> — We typically review applications within 1–2 business days.
        </div>
      )}
    </div>
  );
}
